import * as ActionType from '../ActionType';

const initialState = {
  currentCampaignIdentifier: null,
  currentCampaignIdentifierLoading: false,
  currentCampaignIdentifierError: '',

  campaignsByIdentifier: {},
  campaignsLoading: false,
  campaignsError: '',
};

export const getCurrentCampaign = (state) => ({
  data: state.campaign.campaignsByIdentifier[
    state.campaign.currentCampaignIdentifier
  ],
  loading: state.campaign.currentCampaignIdentifierLoading,
  error: state.campaign.currentCampaignIdentifierError,
});

export const getCurrentCampaignTapSurvey = (state) => ({
  data:
    state.campaign.campaignsByIdentifier[
      state.campaign.currentCampaignIdentifier
    ] &&
    state.campaign.campaignsByIdentifier[
      state.campaign.currentCampaignIdentifier
    ].tap_survey,
  loading: state.status.LOAD_CAMPAIGN_TAP_SURVEY.loading,
  error: state.status.LOAD_CAMPAIGN_TAP_SURVEY.error,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionType.RESET_CURRENT_CAMPAIGN: {
      return {
        ...state,
        currentCampaignIdentifier: null,
        currentCampaignIdentifierLoading: false,
        currentCampaignIdentifierError: '',
      };
    }
    case ActionType.LOAD_CAMPAIGN_FEASIBILITY_SUCCESS: {
      const { identifier, feasibility } = action.payload;
      return {
        ...state,
        campaignsByIdentifier: {
          ...state.campaignsByIdentifier,
          [identifier]: {
            ...state.campaignsByIdentifier[identifier],
            feasibility,
          },
        },
      };
    }
    case ActionType.LOAD_CAMPAIGN_REQUEST: {
      return {
        ...state,
        currentCampaignIdentifierLoading: true,
        currentCampaignIdentifierError: '',
      };
    }
    case ActionType.LOAD_CAMPAIGN_SUCCESS: {
      const { campaign } = action.payload;
      return {
        ...state,

        currentCampaignIdentifier: campaign.identifier,
        currentCampaignIdentifierLoading: false,
        currentCampaignIdentifierError: '',

        campaignsByIdentifier: {
          ...state.campaignsByIdentifier,
          [campaign.identifier]: {
            ...state.campaignsByIdentifier[campaign.identifier],
            ...campaign,
          },
        },
      };
    }
    case ActionType.LOAD_CAMPAIGN_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        currentCampaignIdentifierLoading: false,
        currentCampaignIdentifierError: error,
      };
    }
    case ActionType.SAVE_CAMPAIGN_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        saveError: error,
        saveLoading: false,
      };
    }
    case ActionType.LOAD_CAMPAIGN_TAP_SURVEY_SUCCESS: {
      const { tapSurvey, campaignIdentifier } = action.payload;
      return {
        ...state,
        campaignsByIdentifier: {
          ...state.campaignsByIdentifier,
          [campaignIdentifier]: {
            ...state.campaignsByIdentifier[campaignIdentifier],
            tap_survey: {
              ...state.campaignsByIdentifier[campaignIdentifier].tap_survey,
              ...tapSurvey,
            },
          },
        },
      };
    }
    default:
      return state;
  }
}
